import { Colors } from '.'

export const container = {
    backgroundColor: Colors.background.page,
    height: '100%',
}
